"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prn = void 0;
var uuid_1 = require("uuid");
var Prn = /** @class */ (function () {
    function Prn(service, identifier, uuid, profile) {
        this.Profile = null;
        this.Uuid = null;
        this.Service = service.toUpperCase();
        this.Identifier = identifier.toUpperCase();
        this.Uuid = uuid.toUpperCase();
        this.Profile = profile == null ? null : profile.toUpperCase();
    }
    Prn.validSlug = function (slug) {
        if (slug === undefined || slug === null || slug.length === 0) {
            return false;
        }
        return /^[a-z0-9._-]*$/gi.test(slug);
    };
    Prn.toSlug = function (slug) {
        if (slug === undefined || slug === null || slug.length === 0) {
            throw Error("Expected Slug");
        }
        slug = slug.replace(" ", "_").toUpperCase();
        return slug.replace(/[^a-z0-9._-]/gi, "");
    };
    Prn.validIdentifier = function (identifier) {
        if (identifier === undefined || identifier === null || identifier.length === 0) {
            return false;
        }
        return /^[a-z0-9._-]*$/gi.test(identifier);
    };
    Prn.toIdentifier = function (parts) {
        return parts.map(function (p) { return Prn.toSlug(p); }).join(Prn.identifierSeperator);
    };
    Prn.generate = function (service, identifier, profile, uuid) {
        if (!Prn.validSlug(service)) {
            throw Error("Invalid Service");
        }
        if (!Prn.validIdentifier(identifier)) {
            throw Error("Invalid Identifier");
        }
        if (uuid === undefined || uuid === null || uuid.length === 0) {
            uuid = (0, uuid_1.v4)().replace(/-/g, "");
        }
        if (!Prn.validSlug(uuid)) {
            throw Error("Invalid UUID");
        }
        if (profile !== null && (profile === undefined || profile.length === 0)) {
            profile = null;
        }
        if (profile !== null && !Prn.validSlug(profile)) {
            throw Error("Invalid Profile");
        }
        return new Prn(service, identifier, uuid, profile);
    };
    Prn.parse = function (raw) {
        if (raw === undefined || raw === null || raw.length === 0) {
            return null;
        }
        var split = raw.split(Prn.seperator);
        if (split.length !== 5) {
            return null;
        }
        if (split[0] !== Prn.prefix) {
            return null;
        }
        var service = split[1];
        if (!Prn.validSlug(service)) {
            return null;
        }
        var profile = split[2];
        if (profile.length !== 0 && !Prn.validSlug(service)) {
            return null;
        }
        var uuid = split[3];
        if (!Prn.validSlug(uuid)) {
            return null;
        }
        var id = split[4];
        if (!Prn.validIdentifier(id)) {
            return null;
        }
        return new Prn(service, id, uuid, profile);
    };
    Prn.deserialize = function (prn) {
        return Prn.generate(prn.Service, prn.Identifier, prn.Profile, prn.Uuid);
    };
    Prn.prototype.toString = function () {
        return "".concat(Prn.prefix).concat(Prn.seperator).concat(this.Service).concat(Prn.seperator).concat(this.Profile).concat(Prn.seperator).concat(this.Uuid).concat(Prn.seperator).concat(this.Identifier);
    };
    Prn.prefix = "PRN";
    Prn.seperator = ":";
    Prn.identifierSeperator = "/";
    return Prn;
}());
exports.Prn = Prn;
